import axios from '@/plugins/axios'

const state = {
  blobsInitialised: false,
  blobs: []
}

// getters
const getters = {
  blobsInitialised (state) {
    return state.blobsInitialised
  },

  blobs (state) {
    return state.blobs
  }
}

// actions
const actions = {
  async loadBlobs({ commit }) {
    commit('addToLoadingQueue', 'load_suggestions_blobs',  { root: true });

    return axios.get('/suggestions/blob')
      .then((response) => {
        commit('setBlobs', response.data);
        commit('setBlobsInitialised');
        commit('removeFromLoadingQueue', 'load_suggestions_blobs',  { root: true });
      })
      .catch((error) => {
        commit('removeFromLoadingQueue', 'load_suggestions_blobs',  { root: true });
        commit('error/newError', {
          title: 'error.suggestion.blobs.load',
          text: error.response? error.response.data.message || error.message: error.message
        }, { root: true});
      });
  },
}

// mutations
const mutations = {
  setBlobsInitialised() {
    this.blobsInitialised = true;
  },

  setBlobs(state, blobs) {
    state.blobs = blobs
  },

  removeBlob(state, blobId) {
    let pos = state.blobs.findIndex(b => b.id == blobId);

    if(pos > -1) {
      state.blobs.splice(pos, 1);
    }
  },

  incBlobCounter(state, blobId) {
    let pos = state.blobs.findIndex(b => b.id === blobId)

    if(pos > -1) {
      let blob = Object.assign({}, state.blobs[pos]);

      blob.add_counter++;

      // replace object and stay reactive
      state.blobs.splice(pos, 1, Object.assign(state.blobs[pos], blob))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
